import { render, staticRenderFns } from "./EndpointTester.vue?vue&type=template&id=666a2bce&"
import script from "./EndpointTester.vue?vue&type=script&lang=js&"
export * from "./EndpointTester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports